import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const Logo = ({ at, className, ...rest }) => {
  return (
    <Link
      to="/"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left mb-0': at === 'navbar-top' },
        className
      )}
      {...rest}
    >
      <div className="psi-brand">
        <div className="psi-brand__mark">PSI</div>
        <div className="psi-brand__copy">
          <strong>Psixologik Panel</strong>
          <span>P-admin dashboard</span>
        </div>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  className: PropTypes.string
};

Logo.defaultProps = {
  at: 'auth',
  className: ''
};

export default Logo;
